import React from 'react';
import { Select, Checkbox, Space } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const { Option } = Select;

const StatusFilters = ({ filters, onChange, darkMode }) => {
  const statusOptions = [
    { id: 1, name: 'Aktif' },
    { id: 2, name: 'Pasif' },
    { id: 3, name: 'İnceleniyor' }
  ];

  const notificationOptions = [
    { id: 1, name: 'Bildirildi' },
    { id: 0, name: 'Bildirilmedi' }
  ];

  const handleStatusChange = (statusIds) => {
    onChange('statusIds', statusIds || []);
  };

  const handleNotificationChange = (notificationIds) => {
    onChange('notificationIds', notificationIds || []);
  };

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Aktif - Pasif
        </label>
        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Durum seçin"
          value={filters.statusIds || []}
          onChange={handleStatusChange}
          allowClear
          maxTagCount="responsive"
        >
          {statusOptions.map(status => (
            <Option key={status.id} value={status.id}>
              {status.id === 1 && <CheckCircleOutlined style={{ marginRight: 4, color: '#52c41a' }} />}
              {status.id === 2 && <CloseCircleOutlined style={{ marginRight: 4, color: '#ff4d4f' }} />}
              {status.id === 3 && <ExclamationCircleOutlined style={{ marginRight: 4, color: '#e8ce99' }} />}
              {status.name}
            </Option>
          ))}
        </Select>
        {filters.statusIds && filters.statusIds.length > 0 && (
          <div style={{ fontSize: 10, color: darkMode ? '#999' : '#666', marginTop: 2 }}>
            {filters.statusIds.length} durum seçildi
          </div>
        )}
      </div>

      <div>
        <label style={{ 
          display: 'block', 
          marginBottom: 4, 
          fontSize: 12,
          color: darkMode ? '#ccc' : '#666'
        }}>
          Bildirim Durumları (çoklu seçim)
        </label>
        <Checkbox.Group 
          value={filters.notificationIds || []} 
          onChange={handleNotificationChange}
          style={{ width: '100%' }}
        >
          <Space direction="vertical" size="small">
            {notificationOptions.map(option => (
              <Checkbox key={option.id} value={option.id}>
                {option.id === 1 && <CheckCircleOutlined style={{ marginRight: 4, color: '#52c41a' }} />}
                {option.id === 0 && <CloseCircleOutlined style={{ marginRight: 4, color: '#ff4d4f' }} />}
                {option.name}
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
        {filters.notificationIds && filters.notificationIds.length > 0 && (
          <div style={{ fontSize: 10, color: darkMode ? '#999' : '#666', marginTop: 2 }}>
            {filters.notificationIds.length} bildirim durumu seçildi
          </div>
        )}
      </div>
    </Space>
  );
};

export default StatusFilters;
